import { runtimeBus } from '../app/runtimeBus';

/** The economy keeps one pause lease while changing its own internal screens. */
export class ModalCoordinator {
  private opened = false;
  private reserved = false;
  private previousFocus: HTMLElement | null = null;
  constructor(private readonly dialog: HTMLDialogElement, private readonly onOpenChange: (open: boolean) => void) {}
  open(): void {
    if (this.opened) return;
    this.reserve();
    this.opened = true;
    this.dialog.showModal();
  }
  reserve(): void {
    if (this.reserved) return;
    this.reserved = true;
    this.previousFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    this.onOpenChange(true);
    runtimeBus.sendUi({ type: 'economy-modal', open: true });
  }
  close(): void {
    if (!this.reserved) return;
    this.reserved = false;
    this.opened = false;
    this.dialog.close();
    this.onOpenChange(false);
    runtimeBus.sendUi({ type: 'economy-modal', open: false });
    if (this.previousFocus?.isConnected && !this.previousFocus.inert) this.previousFocus.focus();
  }
  get isOpen(): boolean { return this.opened; }
}
